import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import type { SupportedCurrencies } from 'frontend-utils/utils/constants/currency-mapping-constants';
import MarketSnapshotsKpiCard from 'lumen/components/market/snapshots/kpi-card';
import type MarketPerformanceKpi from 'lumen/models/market-performance/kpi';
import type { ComparisonMetricType } from 'lumen/utils/constants/market-snapshots-constants';
import type { Variance } from 'lumen/utils/constants/variance';
import {
  buildKpiCardData,
  buildVarianceLabel,
  type KpiCardData,
  type KpiCardName,
} from 'lumen/utils/market-snapshots/kpis';

interface MarketSnapshotsKpiSectionSignature {
  Args: {
    comparisonMetricType: ComparisonMetricType;
    currency: SupportedCurrencies;
    isLoading?: boolean;
    kpiNames: readonly KpiCardName[];
    kpis: MarketPerformanceKpi[];
    varianceType: Variance;
  };
}

export default class MarketSnapshotsKpiSection extends Component<MarketSnapshotsKpiSectionSignature> {
  @service declare intl: Services['intl'];

  get cards(): KpiCardData[] {
    const { comparisonMetricType, kpiNames, kpis, varianceType } = this.args;
    return kpiNames.map((kpiName) =>
      buildKpiCardData(this.intl, kpis, kpiName, {
        comparisonMetricType,
        varianceType,
      }),
    );
  }

  get varianceLabel(): string {
    return buildVarianceLabel(this.intl, this.args.comparisonMetricType);
  }

  <template>
    <div class="flex gap-400">
      {{#each this.cards as |card|}}
        <div class="min-w-0 flex-1">
          <MarketSnapshotsKpiCard
            @currency={{@currency}}
            @isLoading={{@isLoading}}
            @title={{card.title}}
            @total={{card.total}}
            @variance={{card.variance}}
            @varianceLabel={{this.varianceLabel}}
            @varianceType={{@varianceType}}
          />
        </div>
      {{/each}}
    </div>
  </template>
}
